export const getSound = name => {
  switch (name) {
    case 'sleipner':
      return sleipner
    case 'helga1':
      return helga1
    case 'helga2':
      return helga2
    case 'helgaTv':
      return helgaTv
    case 'preben1':
      return preben1
    default:
      return {}
  }
}

const sleipner = {
  src: 'https://snutt.nrk.no/multimedia_apps/playground/Sleipner-lydfiler/Sleipner_lydlogg1.mp3',
  captions: [
    {
      in: 0.2,
      text: '– Rogaland radio,',
      newLine: true
    },
    {
      in: 1.22,
      text: 'Rogaland radio,'
    },
    {
      in: 2.2,
      text: 'Rogaland radio.'
    },
    {
      in: 3.15,
      text: 'Det va'
    },
    {
      in: 6,
      text: '– det va'
    },
    {
      in: 7,
      text: 'Sleipner'
    },
    {
      in: 7.5,
      text: 'Sleipner'
    },
    {
      in: 10,
      text: '– Sleipner, Rogaland radio?',
      newLine: true
    },
    {
      in: 15,
      text: 'Sleipner, Rogaland radio?'
    },
    {
      in: 19.08,
      text: '– Me har en',
      newLine: true
    },
    {
      in: 20.04,
      text: 'nødsituasjon her du'
    },
    {
      in: 21.17,
      text: 'me e oppå Blokso,'
    },
    {
      in: 23.16,
      text: 'nord av Ryvarden fyr'
    },
    {
      in: 28,
      text: 'me trenge assistanse øyeblikkelig.'
    }
  ]
}

const helga1 = {
  src: 'https://static.nrk.no/dh/module/psykiatrien-spesial/assets/helga_1.mp3',
  captions: [
    {
      in: 0,
      text: 'Og alikevel sier jeg: ',
      newLine: true
    },
    {
      in: 1,
      text: 'Nå må dere passe på ham!'
    },
    {
      in: 3,
      text: 'Jeg har skreket en uke, ',
      newLine: true
    },
    {
      in: 4.9,
      text: 'jeg har skreket siden han kom inn her. '
    },
    {
      in: 7,
      text: 'Og dere tar oss ikke alvorlig. '
    },
    {
      in: 9,
      text: 'Hva er det som skjer? '
    },
    {
      in: 12,
      text: 'Jeg sto på startstreken til å få han ut fra dette helvetes sykehuset, '
    },
    {
      in: 16.5,
      text: ' og så klarer dere ikke å passe på han.'
    }
  ]
}

const helga2 = {
  src: 'https://static.nrk.no/dh/module/psykiatrien-spesial/assets/helga_2.mp3',
  captions: [
    {
      in: 0,
      text: 'Jeg har skreket en uke, ',
      newLine: true
    },
    {
      in: 1.6,
      text: 'jeg har skreket siden han kom inn her. '
    },
    {
      in: 3.7,
      text: 'Og dere tar oss ikke alvorlig. '
    },
    {
      in: 5.7,
      text: 'Hva er det som skjer? '
    },
    {
      in: 8,
      newLine: true,
      text: 'Jeg sto på startstreken '
    },
    {
      in: 10,
      text: 'til å få han ut fra dette helvetes sykehuset, '
    },
    {
      in: 12.7,
      text: ' og så klarer dere ikke å passe på han.'
    }
  ]
}

const helgaTv = {
  src: 'https://static.nrk.no/dh/module/psykiatrien-spesial/assets/helga_tv.mp3',
  captions: [
    {
      in: 1.4,
      text: 'Jeg hadde aldri, ',
      newLine: true
    },
    {
      in: 2.5,
      text: 'aldri '
    },
    {
      in: 3.1,
      text: '<br>sett han '
    },
    {
      in: 3.7,
      text: '<strong>så dårlig</strong>.'
    },
    {
      newLine: true,
      in: 6,
      text: 'Så sier jeg '
    },
    {
      in: 6.7,
      text: 'nå må dere '
    },
    {
      in: 7.2,
      text: '<br><strong>ta vare på han.</strong>'
    },
    {
      newLine: true,
      in: 9.5,
      text: 'Det <strong>siste</strong> de sier til meg:'
    },
    {
      newLine: true,
      in: 11,
      text: 'Slapp av. '
    },
    {
      in: 12,
      text: '<br>Nå må du gå hjem å slappe av.'
    },
    {
      in: 13,
      newLine: true,
      text: 'Vi passer på <strong>Preben</strong>.'
    }
  ]
}

const preben1 = {
  src: 'https://static.nrk.no/dh/module/psykiatrien-spesial/assets/preben_2.mp3',
  captions: [
    {
      in: 0.75,
      text: 'Den høye dosen som dere har gitt meg ',
      newLine: true
    },
    {
      in: 3,
      text: 'er totalt urealistisk i min situasjon. '
    },
    {
      in: 5.5,

      text: 'Jeg er ikke noe fare for noen andre, eller meg selv. '
    },
    {
      in: 8,
      text: 'Jeg har balansert kommunikasjon, '
    },
    {
      in: 10.5,
      text: 'og skal ikke medisineres på denne måten i det hele tatt.'
    },
    {
      in: 14.5,
      newLine: true,
      text: 'Jeg blir så dårlig at … '
    },
    {
      in: 14.5,
      text: 'Altså det blir jo helt lammelse. '
    },
    {
      in: 17.5,
      text: 'Jeg kommer til å sove 24 timer '
    },
    {
      in: 19,
      text: 'når jeg går på de medisinene dere har gitt meg. '
    },
    {
      in: 21.5,
      text: 'Er det det som er målet deres med behandling? '
    },
    {
      in: 24.5,
      text: 'Og det er det dere vil?'
    }
  ]
}

/*
Utad er han velstelt og vennlig.
Intelligent og belest.
Han er en smart student, som drømmer om å utgjøre en forskjell i verden. Men inni hodet hans, for andre i hvert fall, vokser kaoset. Han hopper fra tema til tema i samtaler og utbroderer på en kompleks måte om innviklede problemstillinger. Han snakker fort og kan også snakke til seg selv på mange språk. Etter dette. bildekarusell av Preben

*/
